export default __webpack_public_path__ + "static/char-14-anr-c7c992835bfe4f5f6b533e1e6c170a11.webp";